import { render, staticRenderFns } from "./userTable.vue?vue&type=template&id=1aa0b22e&scoped=true"
import script from "./userTable.vue?vue&type=script&lang=js"
export * from "./userTable.vue?vue&type=script&lang=js"
import style0 from "./userTable.vue?vue&type=style&index=0&id=1aa0b22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa0b22e",
  null
  
)

export default component.exports